export const GET_MY_ROOMS_REQUEST = 'GET_MY_ROOMS_REQUEST';
export const GET_MY_ROOMS_SUCCESS = 'GET_MY_ROOMS_SUCCESS';
export const GET_MY_ROOMS_FAIL = 'GET_MY_ROOMS_FAIL';
export const GET_MY_ROOMS_RESET = 'GET_MY_ROOMS_RESET';

export const CREATE_ROOM_REQUEST = 'CREATE_ROOM_REQUEST';
export const CREATE_ROOM_SUCCESS = 'CREATE_ROOM_SUCCESS';
export const CREATE_ROOM_FAIL = 'CREATE_ROOM_FAIL';
export const CREATE_ROOM_RESET = 'CREATE_ROOM_RESET';

export const HANDLE_ACCEPT_ROOM_REQUEST = 'HANDLE_ACCEPT_ROOM_REQUEST';
export const HANDLE_ACCEPT_ROOM_SUCCESS = 'HANDLE_ACCEPT_ROOM_SUCCESS';
export const HANDLE_ACCEPT_ROOM_FAIL = 'HANDLE_ACCEPT_ROOM_FAIL';

export const HANDLE_BLOCK_ROOM_REQUEST = 'HANDLE_BLOCK_ROOM_REQUEST';
export const HANDLE_BLOCK_ROOM_SUCCESS = 'HANDLE_BLOCK_ROOM_SUCCESS';
export const HANDLE_BLOCK_ROOM_FAIL = 'HANDLE_BLOCK_ROOM_FAIL';
export const HANDLE_BLOCK_ROOM_RESET = 'HANDLE_BLOCK_ROOM_RESET';

export const HANDLE_UNBLOCK_ROOM_REQUEST = 'HANDLE_UNBLOCK_ROOM_REQUEST';
export const HANDLE_UNBLOCK_ROOM_SUCCESS = 'HANDLE_UNBLOCK_ROOM_SUCCESS';
export const HANDLE_UNBLOCK_ROOM_FAIL = 'HANDLE_UNBLOCK_ROOM_FAIL';
export const HANDLE_UNBLOCK_ROOM_RESET = 'HANDLE_UNBLOCK_ROOM_RESET';

export const DELETE_ROOM_REQUEST = 'DELETE_ROOM_REQUEST';
export const DELETE_ROOM_SUCCESS = 'DELETE_ROOM_SUCCESS';
export const DELETE_ROOM_FAIL = 'DELETE_ROOM_FAIL';
export const DELETE_ROOM_RESET = 'DELETE_ROOM_RESET';

export const CURRENT_OPEN_ROOM_REQUEST = 'CURRENT_OPEN_ROOM_REQUEST';
export const CURRENT_OPEN_ROOM_SUCCESS = 'CURRENT_OPEN_ROOM_SUCCESS';
export const CURRENT_OPEN_ROOM_FAIL = 'CURRENT_OPEN_ROOM_REQUEST';
export const CURRENT_OPEN_ROOM_RESET = 'CURRENT_OPEN_ROOM_RESET3';

//? non related constants
export const UPDATE_ROOM_PUT_UP = 'UPDATE_ROOM_PUT_UP';
export const UPDATE_ROOM_WITHOUT_PUT_UP = 'UPDATE_ROOM_WITHOUT_PUT_UP';
export const UPDATE_CURRENT_OPEN_ROOM = 'UPDATE_CURRENT_OPEN_ROOM';
export const UPDATE_ROOMS_AFTER_DELETING = 'UPDATE_ROOMS_AFTER_DELETING';
export const TYPING_MESSAGE = 'TYPING_MESSAGE';
//? non related constants
